export const CONTENT_WIDTH = '1240px'
